import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';

const NotificationCloseButton = ({ closeSnackbar, id }) => {
    return <Button size='small' onClick={() => closeSnackbar(id)}>
        <CloseIcon />
    </Button>
}

export default NotificationCloseButton;